import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Icon,
} from "@mui/material";

// import icon delete from material icons
import DeleteIcon from "@mui/icons-material/Delete";

import CategorySelector from "../category_selector/Main";
import { GET } from "../../utils/requests";

import VendorFinder from "../vendor_finder/Main";
import InvoiceNumber from "../invoice_number/Main";
import InvoiceDate from "../invoice_date/Main";
import InvoiceAmount from "../invoice_amount/Main";
import ItemNumberFinder from "../item_number_finder/Main";
import ItemNameFinder from "../item_name_finder/Main";
import Quantity from "../quantity/Main";
import UnitPrice from "../unit_price/Main";
import Subtotal from "../subtotal/Main";

const ACCOUNT_ID = 1;
const DEFAULT_CATEGORY_ID = 45;


const DEFAULT_VALUE = {
  vendor: {
    current: {
      value: "",
      name: "",
    },
    reference: {
      reference_id: 26112,
    }
  },
  invoice_number: {
    current: {
      value: "",
      warning: null,
      message: 'Please be careful entering the invoice number. This is a critical field for matching invoices to payments.',
    },
    reference: {
      current_value: "INV0001",
    }
  },

  invoice_date: {
    current: {
      value: "",
    },
    reference: {
      current_value: "08/31/2024",
    }
  },

  invoice_amount: {
    current: {
      value: "",
    },
    reference: {
      current_value: "100.00",
    }
  },
}

const DEFAULT_LINE_ITEMS = [
  {
    item_number: {
      current: {
        value: "",
      },
      reference: {
        current_value: "962064",
      }
    },
    item_name: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    qty: {
      current: {
        value: "",
      },
      reference: {
        current_value: "10",
      }
    },
    unit_price: {
      current: {
        value: "",
      },
      reference: {
        current_value: "100.00",
      }
    },
    category: {
      current: {
        value: "",
      },
      reference: {
        reference_id: "72",
      }
    },
    subtotal: {
      current: {
        value: "100.57",
      },
      reference: {
        current_value: "100.00",
      }
    },
  },
  {
    item_number: {
      current: {
        value: "",
      },
      reference: {
        current_value: "962064",
      }
    },
    item_name: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    qty: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    unit_price: {
      current: {
        value: "",
      },
      reference: {
        current_value: "100.00",
      }
    },
    category: {
      current: {
        value: "",
      },
      reference: {
      }
    },
    subtotal: {
      current: {
        value: "",
      },
      reference: {
        current_value: "100.00",
      }
    },
  }
]

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})
  const [line_items, setLineItems] = useState([...DEFAULT_LINE_ITEMS])

  const [vendor_value, setVendorValue] = useState(null)
  const [invoice_number_value, setInvoiceNumberValue] = useState({...DEFAULT_VALUE.invoice_number.current})
  const [invoice_date_value, setInvoiceDateValue] = useState({...DEFAULT_VALUE.invoice_date.current})
  const [invoice_amount_value, setInvoiceAmountValue] = useState({...DEFAULT_VALUE.invoice_amount.current})

  const [tree_options, setTreeOptions] = useState(null)

  useEffect(() => {
    console.log(value)
    GET({
      url: `/references/categories.json?account_id=${ACCOUNT_ID}`,
      success: (data) => {
        setTreeOptions(data)
      }
    })
  }, [])

  const updateValue = (key, updatedData) => {
    setValue(prevValue => ({
      ...prevValue,
      [key]: {
        ...prevValue[key],
        current: {
          ...prevValue[key]?.current,
          ...updatedData,
        },
      },
    }));
  };

  const updateLineItem = (index, key, updatedData) => {
    setLineItems(prevLineItems => {
      const newLineItems = [...prevLineItems];
      newLineItems[index] = {
        ...newLineItems[index],
        [key]: {
          ...newLineItems[index][key],
          current: {
            ...newLineItems[index][key]?.current,
            ...updatedData,
          },
        },
      };
      return newLineItems;
    });
  };

  const onVendorChange = (val) => {
    setVendorValue(val);
    updateValue('vendor', {
      value: val?.id,
      name: val?.name,
    });
  }

  const onInvoiceNumberChange = (val) => {
    setInvoiceNumberValue(val);
    updateValue('invoice_number', {
      value: val?.value,
    });
  }

  const onInvoiceDateChange = (val) => {
    setInvoiceDateValue(val);
    console.log('val', val);
    updateValue('invoice_date', {
      value: val?.value,
    });
  }

  const onInvoiceAmountChange = (val) => {
    setInvoiceAmountValue(val);
    updateValue('invoice_amount', {
      value: val?.value,
    });
  }

  const onAddLineItem = () => {
    setLineItems(prevLineItems => ([
      ...prevLineItems,
      {
        item_number: {
          current: {
            value: "",
          }
        },
        item_name: {
          current: {
            value: "",
          }
        },
        qty: {
          current: {
            value: "",
          }
        },
        unit_price: {
          current: {
            value: "",
          }
        },
        category: {
          current: {
            value: "",
          }
        },
        subtotal: {
          current: {
            value: "",
          }
        },
      }
    ]));
  }

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <VendorFinder
          default_value={value?.vendor?.reference?.reference_id}
          value={vendor_value}
          show_address={false}
          onChange={onVendorChange}
        />
        <br/>
        <InvoiceNumber
          default_value={value?.invoice_number?.reference?.current_value}
          value={invoice_number_value}
          show_message={false}
          onChange={onInvoiceNumberChange}
        />
        <br/>
        <br/>
        <InvoiceDate
          default_value={value?.invoice_date?.reference?.current_value}
          value={invoice_date_value}
          show_inline_warning={false}
          onChange={onInvoiceDateChange}
        />
        <br/>
        <br/>
        <InvoiceAmount
          default_value={value?.invoice_amount?.reference?.current_value}
          value={invoice_amount_value}
          show_message={false}
          onChange={onInvoiceAmountChange}
        />
        <hr/>
        Line Items
        <table className="table table-bordered line-items-table">
          <thead>
            <tr>
              <th style={{width: "200px"}}>Item Number</th>
              <th>Item Name</th>
              <th style={{width: "270px"}}>Category</th>
              <th style={{width: "70px"}}>QTY</th>
              <th style={{width: "120px"}}>Unit Price</th>
              <th style={{width: "100px"}}>Subtotal</th>
              <th style={{width: "40px"}}></th>
            </tr>
          </thead>
          <tbody>
            {line_items.map((line_item, index) => (
              <tr>
                <td>
                  <ItemNumberFinder
                    vendor_id={vendor_value?.value}
                    value={line_item.item_number?.current}
                    default_value={line_item.item_number?.reference?.current_value}
                    onChange={(val) => {
                      const local_val = val || {id: "", value: "", name: "", label: ""};
                      updateLineItem(index, 'item_number', local_val);
                      if(val !== null) {
                        const ref_val = {...local_val, name: local_val?.item_name};
                        updateLineItem(index, 'item_name', ref_val);
                      } else {
                        updateLineItem(index, 'item_name', local_val);
                      }
                    }}
                  />
                </td>
                <td>
                  <ItemNameFinder
                    vendor_id={vendor_value?.value}
                    value={line_item.item_name?.current}
                    onChange={(val) => {
                      const local_val = val || {id: "", value: "", name: "", label: ""};
                      updateLineItem(index, 'item_name', local_val);
                      if(val !== null) {
                        const ref_val = {...local_val, name: local_val?.item_number};
                        updateLineItem(index, 'item_number', ref_val);
                      } else {
                        updateLineItem(index, 'item_number', local_val);
                      }
                    }}
                  />
                </td>
                <td>
                  {tree_options && <>
                    <CategorySelector
                      default_value={line_item.category?.reference?.reference_id}
                      tree_options={tree_options}
                      value={line_item.category?.current}
                      onChange={(val) => {
                        const local_val = val || {id: "", value: "", name: "", label: ""};
                        updateLineItem(index, 'category', local_val)
                      }}
                    />
                  </>}
                </td>
                <td>
                  <Quantity
                    default_value={line_item.qty?.reference?.current_value}
                    value={line_item.qty?.current}
                    onChange={(val) => updateLineItem(index, 'qty', val)}
                  />
                </td>
                <td>
                  <UnitPrice
                    default_value={line_item.unit_price?.reference?.current_value}
                    value={line_item.unit_price?.current}
                    onChange={(val) => updateLineItem(index, 'unit_price', val)}
                  />
                </td>
                <td>
                  <Subtotal value={{value: `${((parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0)).toFixed(2)}`}} />
                </td>
                <td className="text-center">
                  <Button
                    color="warning"
                    size="small"
                    className="mt-2"
                    onClick={() => {
                      setLineItems(prevLineItems => {
                        const newLineItems = [...prevLineItems];
                        newLineItems.splice(index, 1);
                        return newLineItems;
                      });
                    }}
                  >
                    <DeleteIcon />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5">Total</td>
              <td>
                {(line_items.reduce((acc, line_item) => {
                  return acc + (parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0);
                }, 0.00)).toFixed(2)}
              </td>
              <td></td>
            </tr>
            <tr>
              <td colSpan="7" className="text-end">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={onAddLineItem}
                >
                  Add Line Item
                </Button>
              </td>
            </tr>
          </tfoot>
        </table>
      </Box>
      <p className="alert alert-info">
        Vendor Value: {value?.vendor?.current?.value} {value?.vendor?.current?.name}
        <br/>
        Invoice Number Value: {value?.invoice_number?.current?.value}
        <br/>
        Invoice Date Value: {value?.invoice_date?.current?.value}
        <br/>
        Invoice Amount Value: {value?.invoice_amount?.current?.value}
        <br/>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Item Number</th>
              <th>Item Name</th>
              <th>Category</th>
              <th>QTY</th>
              <th>Unit Price</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {line_items.map((line_item, index) => (
              <tr>
                <td>{line_item.item_number?.current?.value}</td>
                <td>{line_item.item_name?.current?.item_name}</td>
                <td>{line_item.category?.current?.value}</td>
                <td>{line_item.qty?.current?.value}</td>
                <td>{line_item.unit_price?.current?.value}</td>
                <td>{((parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0)).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5">Total</td>
              <td>
                {(line_items.reduce((acc, line_item) => {
                  return acc + (parseFloat(line_item.qty?.current?.value) || 0.00) * (parseFloat(line_item.unit_price?.current?.value) || 0);
                }, 0.00)).toFixed(2)}
              </td>
            </tr>
          </tfoot>
        </table>
      </p>
    </>
  )
}

export default Demo;
